// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseAllowedCaseStatusModel } from './caseAllowedCaseStatusModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseAllowedCaseStatusModels {
    'success': boolean;
    'messages': Array<string>;
    'data': Array<CaseAllowedCaseStatusModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseAllowedCaseStatusModels>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<CaseAllowedCaseStatusModel>"
        },
    ];

    static getAttributeTypeMap() {
        return CaseAllowedCaseStatusModels.attributeTypeMap;
    }
}
